import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

interface Clinic {
  id: string;
  name: string;
}

/**
 * Hook to get all clinics a user has access to.
 * Currently returns only the user's primary clinic from their profile.
 * In the future, this could be extended to support multi-clinic access via a junction table.
 */
export function useUserClinics() {
  const { profile } = useAuth();

  return useQuery({
    queryKey: ['user-clinics', profile?.id],
    queryFn: async (): Promise<Clinic[]> => {
      if (!profile?.clinic_id) return [];

      // For now, just return the user's primary clinic
      // Multi-clinic access could be implemented via a user_clinic_access table
      const { data, error } = await supabase
        .from('clinics')
        .select('id, name')
        .eq('id', profile.clinic_id);

      if (error) throw error;
      return data ?? [];
    },
    enabled: !!profile?.clinic_id,
  });
}
